module.exports = __webpack_public_path__ + "static/media/preparing.a4f0c04f.png";